import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { InstallationItem, InstallationItemGatewayDevice } from '@vi-iot/client';

import { MapActions } from './map.actions';
import { MapSelectors } from './map.selectors';

@Injectable({ providedIn: 'root' })
export class MapStore {
  state$ = this.store.select(MapSelectors.getState());
  installations$ = this.store.select(MapSelectors.getInstallations());
  mapCenter$ = this.store.select(MapSelectors.getMapCenter());

  constructor(private store: Store) {}

  loadAllInstallations(): void {
    this.store.dispatch(MapActions.listInstallations());
  }

  loadInstallation(installationId: number): void {
    this.store.dispatch(MapActions.loadInstallation({ installationId }));
  }

  search(searchParam: string): void {
    if (searchParam) {
      this.store.dispatch(MapActions.searchInstallations({ searchParam }));
    } else {
      this.store.dispatch(MapActions.clearSearch());
    }
  }

  clearSearch(): void {
    this.store.dispatch(MapActions.clearSearch());
  }

  selectInstallation(installation: InstallationItem): void {
    this.store.dispatch(MapActions.selectInstallation({ selectedInstallation: installation }));
  }

  unselectInstallation(): void {
    this.store.dispatch(MapActions.unselectInstallation());
  }

  selectMainDevices(installationId: number): Observable<InstallationItemGatewayDevice[]> {
    return this.store.select(MapSelectors.getInstallationMainDevices(installationId));
  }
}
